module.exports = __webpack_public_path__ + "static/media/coffee-maker.c3289d65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coffee-maker.png
// module id = 1054
// module chunks = 0